import type {Delimiter} from 'mdast'

export type EscapeContinuationMode = 'escapeBlockquote' | 'escapeList' | 'all'

/** Remove prefixes to escape current node based on the `escapeMarkdownContinuation` value. */
export function removeEscapedPrefixes(
  prefixes: readonly Delimiter[],
  mode: EscapeContinuationMode | undefined,
): readonly Delimiter[] {
  switch (mode) {
    case 'escapeBlockquote':
      return prefixes.slice(
        0,
        prefixes.findLastIndex(prefix => prefix.tokenType === 'blockQuotePrefix'),
      )
    case 'escapeList':
      return prefixes.slice(
        0,
        prefixes.findLastIndex(
          prefix => prefix.tokenType === 'listItemPrefix' || prefix.tokenType === 'listItemIndent',
        ),
      )
    case 'all':
      return []
    case undefined:
      return prefixes
  }
}

/** Get the string (indentation whitespace) to continue this list item on a following line. */
export function buildItemContinuationSyntax(marker: string): string {
  return ' '.repeat(marker.length)
}

/** Returns the syntax that, if prepended to following lines, will continue the nodes at the given offset. */
export function buildContinuationSyntax(prefixes: readonly Delimiter[]): string {
  return prefixes
    .map(prefix => {
      switch (prefix.tokenType) {
        case 'listItemPrefix':
          // List items continue as hanging indent matching the prefix size. Note this isn't for creating new items
          // -- that happens on an enter keypress handler. This filter is for continuing the current item, like when
          // pasting into it.
          return buildItemContinuationSyntax(prefix.raw)
        case 'taskListCheck':
          return ''
        default:
          return prefix.raw
      }
    })
    .join('')
}
